import React, { Component } from 'react';
import Select from 'react-select';
import moment from 'moment';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GreyButton } from '../../../GreyButton';

const customStyles = {
  control: (styles) => ({
    ...styles,
    height: '2.5rem',
    border: '1px solid #abadae',
    marginTop: '0.4rem',
    boxShadow: '0 1px 0 0 rgba(46, 50, 53, 0.1)',
    fontWeight: '400',
    textAlign: 'left',
  }),
  option: (provided) => ({
    ...provided,
    fontWeight: '400',
    textAlign: 'left',
  }),
};

const methodOptions = [
  {
    value: 'sms',
    label: 'sms',
  },
  {
    value: 'email',
    label: 'email',
  },
];

const snoozeOptions = [
  {
    value: undefined,
    label: 'Do not snooze',
  },
  {
    value: moment().add(3, 'hours').format(),
    label: '3 Hours',
  },
  {
    value: moment().add(8, 'hours').format(),
    label: '8 Hours',
  },
  {
    value: moment().add(24, 'hours').format(),
    label: '24 Hours',
  },
  {
    value: moment().add(1, 'week').format(),
    label: '1 Week',
  },
];

export class AlertConfigurationSubscribers extends Component {
  fieldToOption(value) {
    const valueString = value.toString();
    return {
      value: value,
      label: valueString.charAt(0).toUpperCase() + valueString.slice(1),
    };
  }

  filterMethodOptions = (name) => {
    const { subscribers } = this.props;
    let filterMethodOptions = methodOptions;

    // if the subscriber exists
    subscribers.map((subscriber) => {
      if (subscriber.name === name) {
        filterMethodOptions = filterMethodOptions.filter((option) => option.value !== subscriber.method);
      }

      return filterMethodOptions;
    });

    return filterMethodOptions;
  };

  handleUnsnooze = (i) => {
    const { onSubscriberSelectChange } = this.props;

    onSubscriberSelectChange(i, moment().format(), 'deactivate_until');
  };

  render() {
    const {
      subscribers,
      validSubscribers,
      handleSubscriberTextChange,
      onSubscriberSelectChange,
      removeRow,
    } = this.props;

    return (
      <div>
        {subscribers.map((subscriber, i) => {
          const { phone_number, email, frequency, method, name, is_snoozed } = subscriber;

          return (
            <div key={i} className="alert-configuration__legend-item">
              <div className="alert-configuration__alert-condition-input-wrapper">
                <Select
                  id={`name${i}-select`}
                  options={validSubscribers}
                  styles={customStyles}
                  className="alert-configuration__select-dropdown"
                  onChange={(selecteOption) => {
                    onSubscriberSelectChange(i, selecteOption.value, 'name');
                  }}
                  value={this.fieldToOption(name)}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <input
                  type="text"
                  id={`phone${i}-input`}
                  className="alert-configuration__text-input"
                  name="phone"
                  value={phone_number}
                  readOnly={true}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <input
                  type="text"
                  id={`email${i}-input`}
                  className="alert-configuration__text-input"
                  name="email"
                  value={email}
                  readOnly={true}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <input
                  type="text"
                  id={`frequency${i}-input`}
                  className="alert-configuration__text-input"
                  name="frequency"
                  value={frequency}
                  onChange={(e) => handleSubscriberTextChange(i, e)}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <Select
                  id={`method${i}-select`}
                  options={this.filterMethodOptions(name)}
                  styles={customStyles}
                  className="alert-configuration__select-dropdown"
                  onChange={(selecteOption) => {
                    onSubscriberSelectChange(i, selecteOption.value, 'method');
                  }}
                  value={this.fieldToOption(method)}
                />
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                {is_snoozed ? (
                  <GreyButton label="Unsnooze" onClick={() => this.handleUnsnooze(i)} />
                ) : (
                  <Select
                    id={`snooze${i}-select`}
                    options={snoozeOptions}
                    styles={customStyles}
                    className="alert-configuration__select-dropdown"
                    onChange={(selectedOption) => {
                      onSubscriberSelectChange(i, selectedOption.value, 'deactivate_until');
                    }}
                  />
                )}
              </div>
              <div className="alert-configuration__alert-condition-input-wrapper">
                <div className="alert-configuration__alert-icon">
                  <span
                    className="alert-configuration__alert-condition-button"
                    onClick={() => removeRow(i, subscribers, 'subscribers')}
                  >
                    <FontAwesomeIcon icon={faTrash} size="lg" color="#0295a6" />
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
